import { useEffect, useRef } from "react";

const SelectPopUp = ({
  visible,
  data = [],
  onClose,
  onSelect,
  style,
}) => {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      ref={popupRef}
      className="w-[350px] bg-white border border-gray-300 rounded-md overflow-y-scroll p-[10px] absolute z-10 top-[50px] left-[0px]"
      style={style}
    >
      <div className="w-full overflow-y-scroll max-h-[120px]">
        {data.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              onSelect(item);
              onClose();
            }}
            className="flex flex-row items-center w-full py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:px-[10px] hover:rounded-xl"
          >
            <p className="font-medium PoppinsRegular text-sm ml-[10px]">
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectPopUp;